/**
 * HomePage — the "/" route component.
 * Renders all ten homepage sections. All CTAs are plain router links to the
 * /intake page — there is no CustomEvent and no modal state here.
 *
 * Per-route concerns owned here:
 *  - FAQ JSON-LD schema (FAQPage structured data)
 *  - Helmet meta tags for the root URL
 *
 * Site-global concerns (Nav, Footer, MerlinCallWidget, org/service schemas)
 * are owned by RootLayout and are NOT repeated here.
 */
import { Helmet } from 'react-helmet-async';
import Hero from '../components/sections/Hero.jsx';
import ForWho from '../components/sections/ForWho.jsx';
import Offers from '../components/sections/Offers.jsx';
import FlagshipBuilds from '../components/sections/FlagshipBuilds.jsx';
import HowWeWork from '../components/sections/HowWeWork.jsx';
import Process from '../components/sections/Process.jsx';
import FAQ from '../components/sections/FAQ.jsx';
import CTA from '../components/sections/CTA.jsx';
import SchemaJsonLd from '../components/primitives/SchemaJsonLd.jsx';
import { faqItems } from '../content/faq.js';

const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.a,
    },
  })),
};

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>The Artificer's AI — AI-native business systems for founders who've outgrown their setup</title>
        <meta
          name="description"
          content="AI-native business systems, founder cohorts, and team training. Built in Perth, working worldwide."
        />
        <link rel="canonical" href="https://artificersai.com/" />
        <meta property="og:title" content="The Artificer's AI — AI-native business systems" />
        <meta
          property="og:description"
          content="AI-native business systems, founder cohorts, and team training. Built in Perth, working worldwide."
        />
        <meta property="og:url" content="https://artificersai.com/" />
      </Helmet>

      <Hero />
      <ForWho />
      <Offers />
      <FlagshipBuilds />
      <HowWeWork />
      <Process />
      <FAQ />
      <CTA />

      <SchemaJsonLd data={faqPageSchema} />
    </>
  );
}
